/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'data': {
    width: 16,
    height: 16,
    viewBox: '0 0 34 34',
    data: '<path pid="0" d="M21.2 30.8c.6 0 1.1-.5 1.1-1.1v-19c0-.6-.5-1.1-1.1-1.1H6.4c-.6 0-1.1.5-1.1 1.1v19c0 .6.5 1.1 1.1 1.1h14.8zm0 2H6.4c-1.7 0-3.1-1.4-3.1-3.1v-19c0-1.7 1.4-3.1 3.1-3.1h14.8c1.7 0 3.1 1.4 3.1 3.1v19c0 1.7-1.4 3.1-3.1 3.1z"/><path pid="1" d="M10.7 3.2c-.6 0-1-.4-1-1s.4-1 1-1h16.9c1.7 0 3.1 1.4 3.1 3.1v21.1c0 .6-.4 1-1 1s-1-.4-1-1V4.3c0-.6-.5-1.1-1.1-1.1H10.7z"/>'
  }
})
